module.exports = __webpack_public_path__ + "static/media/snowboarding.aae4376e.svg";